import { DashboardScreen } from './overview/DashboardScreen';
import { OperationsUpdate } from './overview/OperationsUpdate';
import { Presentation } from './overview/Presentation';
import { WellProgress } from './overview/WellProgress';
import { WellDiagram } from './overview/WellDiagram';
import { WellPrognosis } from './overview/WellPrognosis';
import { RtTimeLog } from './rtlogs/RtTimeLog';
import { RtTimeDepth } from './rtlogs/RtTimeDepth';
import { LogScreen } from './rtlogs/LogScreen';
import { Documents } from './Documents';
import type { NavTab, ScreenKey } from '../lib/nav';
import type { Dashboard as DashboardData } from '../lib/types';

/** Draws the screen a tab points at; see SCREENS in lib/nav/rails for the list. */
export function Screen({
  screen,
  tab,
  data,
  wellId,
  wellName,
}: {
  screen: ScreenKey;
  /** The tab the screen is open in; a log reads its role default from it. */
  tab: NavTab;
  data: DashboardData | null;
  wellId: number;
  wellName: string;
}) {
  switch (screen) {
    case 'dashboard':
      return data ? <DashboardScreen data={data} /> : null;
    case 'operations-update':
      return <OperationsUpdate />;
    case 'presentation':
      return <Presentation />;
    case 'well-progress':
      return <WellProgress />;
    case 'well-diagram':
      return <WellDiagram />;
    case 'well-prognosis':
      return <WellPrognosis />;
    case 'rt-time-log':
      return <RtTimeLog wellId={wellId} />;
    case 'rt-time-depth':
      return <RtTimeDepth wellId={wellId} />;
    case 'rt-depth-log':
      return <LogScreen key={tab.id} wellId={wellId} tab={tab} preset="rt-depth" title="RT DEPTH LOG" />;
    case 'composite-log':
      return <LogScreen key={tab.id} wellId={wellId} tab={tab} preset="composite" title="RT COMPOSITE LOG" />;
    case 'pressure-log':
      return <LogScreen key={tab.id} wellId={wellId} tab={tab} preset="pressure" title="PRESSURE LOG" />;
    case 'rt-pore-pressure':
      return <LogScreen key={tab.id} wellId={wellId} tab={tab} preset="pore-pressure" title="RT PORE PRESSURE" />;
    case 'documents':
      return <Documents wellId={wellId} wellName={wellName} />;
  }
}
